const email_input = document.getElementById('id_username');
const check = document.getElementById('check_icon');
const uncheck = document.getElementById('uncheck_icon');
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

if (email_input) {
    email_input.addEventListener('input', () => {
        const email = email_input.value.trim();

        if (email === '') {
            check.classList.add('hidden');
            uncheck.classList.add('hidden');
        }
        else {
            if (!emailRegex.test(email)) {
                check.classList.add('hidden');
                uncheck.classList.remove('hidden');
            } else {
                check.classList.remove('hidden');
                uncheck.classList.add('hidden');
            }
        }

    });
}